import { defineMessages } from 'react-intl';

export default defineMessages({
	shareWith: {
		defaultMessage: 'Share with {orgName}',
		description: 'Label descibing the organisation the user is sharing their request with',
		id: 'cv.request.create.form.organisation.picker',
	},
	privateRequest: {
		defaultMessage: 'No one',
		description: 'Label indicating the user is making a private request',
		id: 'cv.request.create.form.organisation.picker.private',
	},
	shareWithLabel: {
		defaultMessage: 'Share with',
		description: 'Organisation picker field label',
		id: 'cv.request-create-form.organisation.picker.shareWithLabel',
	},
});
